<template>
  <tdhvp-doc-in-index-common
    :listFn="options => this.list(options)"
    @viewDetail="viewDetail"
  ></tdhvp-doc-in-index-common>
</template>

<script>
import { vbIncomingDocUserTdhvpViewService } from "../../../services/tdhvp/vbIncomingDocUserTdhvpViewService";
import TdhvpDocInIndexCommon from "./tdhvp-doc-in-index-common";

export default {
  name: "tdhvp-doc-in-index",
  components: {
    TdhvpDocInIndexCommon
  },

  data() {
    return {};
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  methods: {
    viewDetail({ item }) {
      this.$router.push({
        name: "tdhvpDocInDetail",
        params: { id: item.docId, userDeptRoleId: this.userDeptRoleId },
        query: this.$route.query
      });
    },

    list({ form, pageable }) {
      return vbIncomingDocUserTdhvpViewService
        .findAll(form, pageable)
        .then(response => response.data);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/doc-in/tdhvp-doc-in-index.vue